<template>
  <div class="privateChat">
    <commonTable
      ref="commonTable"
      url="/admin/callback_money/callback_list"
      reqMethod="GET"
      :column="column"
      :extraParams="extraParams"
      :searchColumn="searchColumn"
      @reset="() => {
        extraParams = { game_id: null }
        dateColumn = false
      }"
      limitKey="per_page"
      @onGetData="onGetData"
      @onSearch="() => dateColumn = false"
    >
      <template slot="search-back">
        <el-form-item>
          <el-select
            v-model="extraParams.game_id"
            clearable
            filterable
            placeholder="游戏列表">
            <el-option
              v-for="item in gamesList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </template>
    </commonTable>
  </div>
</template>

<script>
import fetch from "@/assets/js/axios.js"
import commonTable from '@/component/commonTable.vue'

export default {
  name: 'payReport',
  data () {
    return {
      extraParams: {
        game_id: null,
      },
      gamesList: [],
      dateColumn: false,
      column: [],
      fixedColumn: [
        {
          label: "日期",
          prop: "this_date",
          fixed: true,
          width: '110'
        },
        {
          label: "游戏",
          prop: "game.name",
          fixed: true,
          width: '100',
        },
        {
          label: "总付费",
          prop: "money",
          fixed: true,
          width: '100',
        },
      ]
    }
  },
  computed: {
    searchColumn () {
      return [
        {
          label: "日期",
          prop: "created_from+created_to",
          type: "datetime",
          setDefaultWeek:true
        },
      ]
    }
  },
  components: {
    commonTable
  },
  mounted () {
    this.getGameSelectList()
  },
  methods: {
    onGetData (data) {
      if (!this.dateColumn && data?.length) {
        let column = []
        const date0 = data[0]
        for (let key in date0) {
          if (/^\d{4}(\-|\/|\.)\d{1,2}\1\d{1,2}$/.test(key)) {
            column.push({
              prop: key,
              label: key,
              width: '110'
            })
          }
        }
        if (column?.length) {
          this.dateColumn = true
          this.column = this.fixedColumn.concat(column)
          this.$refs.commonTable.layout()
        }
      }
    },
    // 获取游戏选择列表数据
    getGameSelectList() {
      fetch({
        url: "/admin/games/select",
        method: "GET",
      }).then((res) => {
        this.gamesList = res.data.data
      })
    },
  }
}
</script>

<style lang="less">
.privateChat .el-image-viewer__close {
  top: 100px;
  color: red;
}
</style>
